// extracted by mini-css-extract-plugin
export var legendBlockTitle = "cx_hB";
export var title = "cx_bH";
export var wrapper = "cx_bF";